import { EventEmitter } from '@angular/core';
import { CommonService } from "../common.service";
import { ApiService } from "../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { AbilityConfig } from "../ability-config/ability-config";
import { PlatformLocation } from '@angular/common';
var CasePracticeInfluenceProListComponent = (function () {
    function CasePracticeInfluenceProListComponent(commonService, apiService, platformLocation, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.platformLocation = platformLocation;
        this.route = route;
        this.router = router;
        this.onGoToNextStep = new EventEmitter();
        this.onSetPracticeIndex = new EventEmitter();
        this.showReport = false;
        /* 精彩瞬间 */
        this.showMoment = false;
        this.momentList = [];
        //学习 metaId
        this.learningPathMetaId = 0;
        this.isShowQuestionnaire = false;
        this.questionnaireInfo = null;
        this.isOpenClass = 0;
        this.approachTheme = {};
        this.currentIndex = 0;
        this.isShowApproach = false;
        this.isCustomLock = false;
        this.lock = false;
        this.isShowToast = false;
        //第一次提示的位置
        this.toastIndex = -1;
        //toast是否提示过
        this.showToast = false;
    }
    Object.defineProperty(CasePracticeInfluenceProListComponent.prototype, "showGoToSurveyBtn", {
        get: function () {
            return this.practiceList.every(function (item) {
                return item.status === 2;
            });
        },
        enumerable: true,
        configurable: true
    });
    CasePracticeInfluenceProListComponent.prototype.ngOnInit = function () {
        var _this = this;
        var temp = true;
        var that = this;
        this.abilityConfig = new AbilityConfig(this.apiService, this.commonService);
        this.isOpenClass = Number(localStorage.getItem("openClass")) ? 1 : 0;
        localStorage.setItem("moduleId", "3");
        this.projectId = localStorage.getItem("projectId");
        var projectmsg = JSON.parse(localStorage.getItem('projectmsg'));
        if (this.projectId && projectmsg) {
            projectmsg.map(function (item) {
                if (item.type == 4 && item.lockType == 1) {
                    _this.lock = item.lock;
                    _this.promptText = "\u80FD\u529B\u8003\u6838\u5C06\u4E8E" + item.promptTime + "\u5F00\u653E\u3002";
                }
            });
        }
        //loadconfig
        this.apiService.loadConfig("./assets/config/practiceList.json").subscribe(function (result) {
            _this.practiceList.forEach(function (item, index) {
                if (result[item.title] != null) {
                    item["extends"] = result[item.title];
                }
            });
        });
        this.getLearningTour().then(function (result) {
            _this.learningPathMetas = result.learning_path_metas;
            _this.learningTour = result.pre_survey_meta_ids.length > 0;
        }).then(function () {
            return _this.getOnceinoByPracticeMetaId(_this.practiceMetaId).then(function (result) {
                return _this.finishStatus = result == 1;
            });
        }).then(function () {
            _this.getLearningPathMetaId();
        }).then(function () {
            return _this.getLearningPath(_this.learningPathMetaId).then(function (result) {
                return _this.learningPath = result;
            });
        }).then(function () {
            return _this.getUserQuestionnaireInfo(_this.learningPathMetaId).then(function (result) {
                return _this.questionnaireInfo = result;
            });
        }).then(function () {
            //增加学习断点
            _this.commonService.addUserBreakPoint({ 'learningPathMetasId': Number(_this.learningPathMetaId), 'moduleId': 3, 'breakpointUrl': _this.platformLocation['location']['href'], 'projectId': localStorage.getItem("projectId") ? localStorage.getItem("projectId") : null }).then();
            _this.commonService.setCustomLockDate(_this.learningPath, Date());
            _this.isCustomLock = _this.learningPath.subItems[3].isLock;
            _this.isShowQuestionnaire = _this.questionnaireInfo && _this.questionnaireInfo.length === 0 && _this.learningPath.subItems.filter(function (d) { return d.type === 3; })[0].progress === 100 && _this.learningPath.subItems.filter(function (d) { return d.type === 4; })[0].progress !== 100 ? true : false;
            for (var i = 0; i <= _this.practiceList.length - 1; i++) {
                if (_this.practiceList[i].status != 2) {
                    temp = false;
                }
            }
            _this.finished = temp;
            if (_this.finished) {
                $('#surveyBtn').fadeIn(200);
            }
        });
        this.getPracticeToastIndex();
    };
    //获取进度
    CasePracticeInfluenceProListComponent.prototype.getProgress = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v2/user/learning/progress?learningPathMetaIds=' + String(learningPathMetaId),
        }).toPromise();
    };
    // 获取getOnceinoByPracticeMetaId
    CasePracticeInfluenceProListComponent.prototype.getOnceinoByPracticeMetaId = function (practiceMetaId) {
        return this.abilityConfig.getOnceinoByPracticeMetaId(practiceMetaId).toPromise();
    };
    // 获取learningTour
    CasePracticeInfluenceProListComponent.prototype.getLearningTour = function () {
        return this.apiService.ajax({
            'type': 'get',
            'url': '/sr/learningtour',
        }).toPromise();
    };
    //获取用户学习 metaid and version
    CasePracticeInfluenceProListComponent.prototype.getLearningPathMetaId = function () {
        var _this = this;
        var that = this;
        this.learningPathMetas.forEach(function (item, i) {
            if (item.learningPathId == that.learningPathId) {
                if (that.type) {
                    $('#learningPathMetaIdContainer').val(item.id);
                }
                that.learningPathMetaId = item.id;
            }
        });
        this.getProgress(this.learningPathMetaId).then(function (result) {
            //向LMS传递进度
            if (localStorage.getItem("source_env") === "LMS_SCORM") {
                _this.commonService.sendDataMessage('type', 'LMS_LEARN_PROGRESS', result[0].progressList[0].progress, "data");
            }
            return _this.currentIndex = result[0]['progressList'][0]['currentItemIndex'] == 4 && result[0]['progressList'][0]['progress'] == 100 ? 5 : result[0]['progressList'][0]['currentItemIndex'];
        }).then(function () {
            _this.approachTheme.colorSystem = 'dark';
            _this.approachTheme.label = ['能力诊断', '课程学习', '情景模拟', '能力考核'];
            _this.approachTheme.currentIndex = that.currentIndex - 2;
            _this.approachTheme.desc = '离完成只差最后一步了，交出你优秀的答卷吧！';
            _this.approachTheme.btnTxt = '开启能力考核';
        }).then(function () {
            _this.isShowApproach = true;
        });
    };
    //获取getLearningPath
    CasePracticeInfluenceProListComponent.prototype.getLearningPath = function (learningPathMetaId) {
        return this.apiService.getOrCreateLearningPath(learningPathMetaId).toPromise();
    };
    CasePracticeInfluenceProListComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
    };
    CasePracticeInfluenceProListComponent.prototype.goToNextStep = function (i) {
        var _this = this;
        localStorage.setItem('influenceProExerciseMetaId', this.practiceList[i].exerciseMetaId);
        // this.commonService.learningPortEventLogByCandy({'learningPathMetaId':this.learningPathMetaId,'module':'进入情景模拟'+(i+1)}).then();
        this.onSetPracticeIndex.emit(i);
        // 如果是访客点击永远从头开始情景模拟
        if (this.userType) {
            this.onGoToNextStep.emit(1);
        }
        else {
            //正式用户流程
            if (this.practiceList[i].status == 2) {
                var link = ['case-practice-report-new', this.practiceId, this.practiceList[i].id, this.learningPathId];
                if (this.practiceMetaId == 10) {
                    link = ['case-practice-report-new-2', this.practiceId, this.practiceList[i].id, this.learningPathId];
                }
                if (this.type) {
                    this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    this.router.navigate(link);
                }
            }
            else if (this.practiceMetaId == 10) {
                var link = ['case-practice-hotel', this.practiceId, this.practiceList[i].id, this.learningPathId];
                if (this.type) {
                    this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    this.router.navigate(link);
                }
            }
            else if (this.practiceMetaId == 16 && [141, 151].indexOf(this.practiceList[i].exerciseMetaId) > -1) {
                var link = ['case-practice-influence-supplier', this.learningPathId, this.practiceId, this.practiceList[i].id, this.practiceList[i].exerciseMetaId];
                if (this.type) {
                    this.router.navigate(link, { queryParams: { type: 'huatek' } });
                }
                else {
                    this.router.navigate(link);
                }
            }
            else if (this.practiceMetaId == 607) {
                if (this.practiceList[i].exerciseMetaId === 60701) {
                    this.apiService.ajax({
                        'type': 'get',
                        'url': '/api/pnoStorePoint/' + this.practiceList[i].id
                    }).subscribe(function (result) {
                        if (result.status == 0 || result.status == 5) {
                            _this.onGoToNextStep.emit(1);
                        }
                        else if (result.status == 10) {
                            $('#exerciseMetaId').val(_this.practiceList[i].exerciseMetaId);
                            // let exerciseMetIdNode = document.getElementById("exerciseMetId") as HTMLInputElement
                            // exerciseMetIdNode.value = this.practiceList[i].exerciseMetaId
                            // console.log(exerciseMetIdNode.value )
                            var link = ['case-practice-influence-pro-main', _this.learningPathId, _this.practiceId, _this.practiceList[i].id];
                            if (_this.type) {
                                _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                            }
                            else {
                                _this.router.navigate(link);
                            }
                            if (_this.practiceList[0].status !== 2) {
                                var exerciseMetaId = $('#exerciseMetaId').val();
                                _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 1, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                                    console.log(result);
                                });
                                console.log(exerciseMetaId);
                                _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
                            }
                        }
                    });
                }
                else {
                    var link = ['case-practice-influence-supplier', this.learningPathId, this.practiceId, this.practiceList[i].id, this.practiceList[i].exerciseMetaId];
                    if (this.type) {
                        this.router.navigate(link, { queryParams: { type: 'huatek' } });
                    }
                    else {
                        this.router.navigate(link);
                    }
                }
            }
            else {
                this.apiService.ajax({
                    'type': 'get',
                    'url': '/api/pnoStorePoint/' + this.practiceList[i].id
                }).subscribe(function (result) {
                    if (result.status == 0 || result.status == 5) {
                        _this.onGoToNextStep.emit(1);
                    }
                    else if (result.status == 10) {
                        $('#exerciseMetaId').val(_this.practiceList[i].exerciseMetaId);
                        console.log($('#exerciseMetaId').val(_this.practiceList[i].exerciseMetaId));
                        var link = ['case-practice-influence-pro-main', _this.learningPathId, _this.practiceId, _this.practiceList[i].id];
                        if (_this.type) {
                            _this.router.navigate(link, { queryParams: { type: 'huatek' } });
                        }
                        else {
                            _this.router.navigate(link);
                        }
                        if (_this.practiceList[0].status !== 2) {
                            var exerciseMetaId = $('#exerciseMetaId').val();
                            _this.apiService.learingTime({ learningPathMetaId: localStorage.getItem('learningPathMetaId'), module: "情景模拟", courseUnit: '', type: 1, btnName: exerciseMetaId, userId: localStorage.getItem("userId") }).subscribe(function (result) {
                                console.log(result);
                            });
                            console.log(exerciseMetaId);
                            _this.commonService.sendPostMessage(0, 'isPractice' + 'Complete');
                        }
                    }
                });
            }
        }
    };
    CasePracticeInfluenceProListComponent.prototype.goToPostSurvey = function () {
        if (this.type === 'huatek') {
            this.commonService.sendPostMessage(1, 'goPostSurvey');
            return;
        }
        else {
            this.commonService.learningPortEventLogByCandy({ 'learningPathMetaId': this.learningPathMetaId, 'module': '情景模拟', 'btnName': this.approachTheme.btnTxt, 'userId': localStorage.getItem("userId") }).then();
            var link = void 0;
            if (this.practiceMetaId == 10) {
                //link = ['survey', this.learningPathId, 13, 1];
                link = ['learning-path', 13];
                this.router.navigate(link);
            }
            else if (this.practiceMetaId == 16) {
                if (this.lock) {
                    this.prompToast();
                    return;
                }
                link = ["ability-survey", this.learningPathMetaId, 2];
                this.router.navigate(link);
            }
            else if (this.practiceMetaId == 607) {
                if (this.lock) {
                    this.prompToast();
                    return;
                }
                link = ["ability-survey", this.practiceMetaId, 2];
                this.router.navigate(link);
            }
            else {
                //link = ['survey', this.learningPathId, 15, 1];
                link = ['learning-path', 15];
                this.router.navigate(link);
            }
        }
    };
    CasePracticeInfluenceProListComponent.prototype.prompToast = function () {
        var _this = this;
        this.isShowToast = true;
        setTimeout(function () {
            _this.isShowToast = false;
        }, 2000);
    };
    CasePracticeInfluenceProListComponent.prototype.finish = function () {
        if (this.finishStatus) {
            return;
        }
        else {
            this.abilityConfig.setOnceinoByPracticeMetaId(this.practiceMetaId).subscribe();
            this.goMain();
        }
    };
    CasePracticeInfluenceProListComponent.prototype.goMain = function () {
        //影响力转向特殊处理
        if (this.practiceMetaId == 9) {
            this.showReport = true;
        }
        else {
            if (this.learningTour) {
                var link = ['learning-map', 3];
                this.router.navigate(link);
            }
            else {
                var link = ['learning-map'];
                this.router.navigate(link);
            }
        }
    };
    CasePracticeInfluenceProListComponent.prototype.goLearnPath = function (pathId) {
        var link = ['learning-path', pathId];
        this.router.navigate(link);
    };
    CasePracticeInfluenceProListComponent.prototype.goLearnPath15 = function () {
        this.goLearnPath(15);
    };
    CasePracticeInfluenceProListComponent.prototype.close = function () {
        var _this = this;
        this.apiService.ajax({
            'type': 'get',
            'url': '/ddilearner/v1/getLearningPathMetaId/' + this.learningPathId
        }).subscribe(function (result) {
            // 只在learningTour里出现，当完成能力是退出进入map
            if ((_this.finishStatus || !_this.finished) && _this.learningTour) {
                var link = ['learning-map', 3];
                _this.router.navigate(link);
            }
            else if (!_this.finishStatus && _this.finished) {
                _this.abilityConfig.setOnceinoByPracticeMetaId(_this.practiceMetaId).subscribe(function (result) {
                    _this.goMain();
                }, function (error) {
                    var link = ['error'];
                    _this.router.navigate(link);
                });
            }
            else {
                var link = ["learning-path", result.data];
                _this.router.navigate(link);
            }
        });
    };
    //展示难忘瞬间gallary
    CasePracticeInfluenceProListComponent.prototype.momentView = function (mlist, $event) {
        this.showMoment = true;
        this.momentList = mlist;
        $event.stopPropagation();
    };
    //关闭难忘瞬间gallary
    CasePracticeInfluenceProListComponent.prototype.momentExit = function () {
        this.showMoment = false;
    };
    CasePracticeInfluenceProListComponent.prototype.getPracticeToastIndex = function () {
        var _this = this;
        this.practiceList.forEach(function (item, i) {
            if (_this.toastIndex == -1 && item.momentsList.length > 0) {
                _this.toastIndex = i;
                return false;
            }
        });
        if (this.toastIndex >= 0) {
            this.getShowToastEnable();
        }
    };
    CasePracticeInfluenceProListComponent.prototype.getShowToastEnable = function () {
        var _this = this;
        //type=11-情景模拟难忘瞬间提示
        this.apiService.ajax({
            'type': 'get',
            'url': '/sr/incentiveLine/firstHints/15/12',
        }).subscribe(function (result) {
            if (result.firstFlag) {
                _this.showToast = true;
                setTimeout(function () {
                    _this.showToast = false;
                }, 2500);
            }
        });
    };
    CasePracticeInfluenceProListComponent.prototype.closeQuestionnaire = function () {
        this.isShowQuestionnaire = false;
    };
    //查询用户相应能力满意度
    CasePracticeInfluenceProListComponent.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        }).toPromise();
    };
    return CasePracticeInfluenceProListComponent;
}());
export { CasePracticeInfluenceProListComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-pro-list/case-practice-influence-pro-list.component.ts.pre-build-optimizer.js